export const SSN_DEFAULT_LABEL = "**********";
